/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PointDirection = {
    Approach: 'Approach',
    Departure: 'Departure',
    Both: 'Both',
    Unknown: 'Unknown'
} as const;
export type PointDirection = typeof PointDirection[keyof typeof PointDirection];

